import _ from 'lodash'
import client from '../../utils/api'
import { createApiAction } from '../../utils/redux-tool'

const basePath = '/api/member/:type/:memberId/course-session-enrollment'
export const search = createApiAction('member/course-session-enrollment/get', client.search(basePath))

export default function setCourseEnrollmentReducers(builder) {
  builder.addCase(search.fulfilled, (state, action) => {
    const list = state.list || []
    const { memberId } = action.meta.arg
    let found = list.find(item => item.id === memberId)
    const foundIndex = list.indexOf(found)
    const replace = _.assign({ id: memberId }, found.courseSessionEnrollment, action.payload)
    if (foundIndex > -1) {
      state.list[foundIndex].courseSessionEnrollment = replace
    } else {
      list.push({ id: memberId, courseSessionEnrollment: { ...action.payload } })
      state.list = list
    }
  })
}
